<div class="main-page">
  <app-header></app-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    
    <!-- Housing Posts List View -->
    <div *ngIf="!showCreateForm" class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="jobs-header">
          <h2 class="jobs-title">Housing Hub</h2>
          <div class="jobs-header-actions">
            <button type="button" class="btn-search" (click)="toggleCreateForm()">
              <i class="fas fa-search"></i> Search
            </button>
            <button type="button" class="btn-add-job" (click)="toggleCreateForm()">
              <i class="fas fa-plus"></i> Add Property
            </button>
            <button type="button" class="btn-all-jobs">
              <i class="fas fa-chevron-down"></i> All Properties
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="housingPosts?.length === 0" class="jobs-empty">
          <img class="jobs-empty-img" src="../../assets/no-data.png" alt="No properties available" />
          <h5 class="jobs-empty-title">No Properties Available</h5>
          <p class="jobs-empty-subtitle">Create your first property listing to get started.</p>
          <button (click)="toggleCreateForm()" class="btn-add-job btn-add-job--empty">
            <i class="fas fa-plus"></i> Add Property
          </button>
        </div>

        <!-- Properties Grid -->
        <div *ngIf="housingPosts?.length > 0" class="jobs-grid">
          <div class="job-card property-card" *ngFor="let post of pagedPosts; let i = index" (click)="openPostDetails(postDetailsModal, post)" style="cursor: pointer;">
            <div class="job-card-badges">
              <span class="job-badge job-badge--expired" *ngIf="isPostExpired(post?.activeTill)">
                EXPIRED
              </span>
              <span class="job-badge job-badge--status" 
                    *ngIf="!isPostExpired(post?.activeTill) && post?.status"
                    [ngClass]="{
                      'job-badge--sold': post.status === 'Sold' || post.status === 'SOLD',
                      'job-badge--rented': post.status === 'Rented' || post.status === 'RENTED',
                      'job-badge--active': post.status === 'Active' || !post.status
                    }">
                {{ post.status?.toUpperCase() || 'ACTIVE' }}
              </span>
              <i class="far fa-heart job-heart" (click)="$event.stopPropagation()"></i>
            </div>
            
            <div class="job-card-content">
              <h3 class="job-title property-title">{{ post?.roomTitle || 'Untitled Property' }}</h3>
              
              <div class="job-details property-details">
                <div class="property-header-info">
                  <div class="job-detail-item property-type">
                    <span class="property-type-label">{{ post?.sellStatus || '-' }}</span>
                  </div>
                  <div class="property-type-info" *ngIf="post?.propertyType">
                    <i class="fas fa-home"></i>
                    <span>{{ post.propertyType }}</span>
                  </div>
                  <div class="property-type-info" *ngIf="post?.housingType">
                    <i class="fas fa-building"></i>
                    <span>{{ post.housingType }}</span>
                  </div>
                </div>

                <div class="property-specs">
                  <div class="property-spec-item" *ngIf="post?.bedRoomCount">
                    <span class="spec-value">{{ post.bedRoomCount }}</span>
                    <span class="spec-label">Bed{{ post.bedRoomCount !== 1 ? 's' : '' }}</span>
                  </div>
                  <div class="property-spec-item" *ngIf="post?.washRoomCount">
                    <span class="spec-value">{{ post.washRoomCount }}</span>
                    <span class="spec-label">Bath{{ post.washRoomCount !== 1 ? 's' : '' }}</span>
                  </div>
                  <div class="property-spec-item" *ngIf="post?.propertyArea">
                    <span class="spec-value">{{ post.propertyArea }}</span>
                    <span class="spec-label">{{ post.propertyUnitArea || 'sq ft' }}</span>
                  </div>
                </div>

                <div class="property-location" *ngIf="getPropertyLocation(post) !== '-'">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ getPropertyLocation(post) }}</span>
                </div>

                <div class="property-price" *ngIf="post?.price">
                  <span class="price-amount">${{ post.price }}</span>
                  <span class="rental-period" *ngIf="post?.rentalPeriod">/ {{ post.rentalPeriod }}</span>
                </div>

                <div class="property-additional-info">
                  <div class="info-item" *ngIf="post?.availableDate">
                    <i class="fas fa-calendar-check"></i>
                    <span>Available: {{ formatDate(post.availableDate) }}</span>
                  </div>
                  <div class="info-item" *ngIf="post?.contactNumber">
                    <i class="fas fa-phone"></i>
                    <span>{{ post.contactNumber }}</span>
                  </div>
                  <div class="info-item" *ngIf="post?.email">
                    <i class="fas fa-envelope"></i>
                    <span>{{ post.email }}</span>
                  </div>
                </div>

                <div class="property-description" *ngIf="post?.description">
                  <p>{{ (post.description.length > 100) ? (post.description | slice:0:100) + '...' : post.description }}</p>
                </div>

                <div class="property-date" *ngIf="post?.activeTill">
                  <i class="fas fa-calendar-alt"></i>
                  <span>Until {{ formatDate(post.activeTill) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="jobs-pagination property-pagination" *ngIf="housingPosts?.length > 0 && totalPages > 1">
          <button class="page-btn" (click)="prevPage()" [disabled]="page <= 1" [attr.aria-label]="'Previous page'">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <span class="page-info">
            Page <strong>{{ page }}</strong> of <strong>{{ totalPages }}</strong>
          </span>
          <button class="page-btn" (click)="nextPage()" [disabled]="page >= totalPages" [attr.aria-label]="'Next page'">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Create Property Form View -->
    <div *ngIf="showCreateForm" class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="responsive">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="event-heading">
                          <span>{{ isEditMode ? 'Update Property Listing' : 'Create Property Listing' }}</span>
                          <button type="button" class="btn-back" (click)="cancel()">
                            <i class="fas fa-arrow-left"></i> Back to Properties
                          </button>
                        </div>
                        
                        <!-- Basic Information Section -->
                        <div class="section-container">
                          <h5 class="section-title">Basic Information</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Sell Status <span class="required">*</span></label>
                                <select class="form-control" formControlName="sellStatus"
                                  [ngClass]="{'is-invalid': submitted && f.sellStatus.errors}">
                                  <option *ngFor="let status of sellStatusOptions" [value]="status">{{status}}</option>
                                </select>
                                <div *ngIf="submitted && f.sellStatus.errors" class="invalid-feedback">
                                  Sell status is required
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Property Type <span class="required">*</span></label>
                                <select class="form-control" formControlName="propertyType"
                                  [ngClass]="{'is-invalid': submitted && f.propertyType.errors}">
                                  <option *ngFor="let type of propertyTypeOptions" [value]="type">{{type}}</option>
                                </select>
                                <div *ngIf="submitted && f.propertyType.errors" class="invalid-feedback">
                                  Property type is required
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Housing Type</label>
                                <select class="form-control" formControlName="housingType">
                                  <option value="">Select Housing Type</option>
                                  <option *ngFor="let type of housingTypeOptions" [value]="type">{{type}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Room/Property Title <span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="roomTitle"
                                  placeholder="e.g., Beautiful 2BR Apartment"
                                  [ngClass]="{'is-invalid': submitted && f.roomTitle.errors}">
                                <div *ngIf="submitted && f.roomTitle.errors" class="invalid-feedback">
                                  Room title is required
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Bedrooms</label>
                                <input type="number" class="form-control" formControlName="bedRoomCount" min="0" placeholder="0">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Bathrooms</label>
                                <input type="number" class="form-control" formControlName="washRoomCount" min="0" placeholder="0">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Property Area</label>
                                <div class="d-flex">
                                  <input type="number" class="form-control" formControlName="propertyArea" min="0" placeholder="0">
                                  <select class="form-control ml-2" formControlName="propertyUnitArea" style="width: 100px;">
                                    <option *ngFor="let unit of propertyUnitOptions" [value]="unit">{{unit}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Lot/Land Area</label>
                                <div class="d-flex">
                                  <input type="number" class="form-control" formControlName="lotLandArea" min="0" placeholder="0">
                                  <select class="form-control ml-2" formControlName="lotUnitArea" style="width: 100px;">
                                    <option *ngFor="let unit of lotUnitOptions" [value]="unit">{{unit}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Status</label>
                                <select class="form-control" formControlName="status">
                                  <option *ngFor="let status of statusOptions" [value]="status">{{status}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Pricing Section -->
                        <div class="section-container">
                          <h5 class="section-title">Pricing Information</h5>
                          
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Price</label>
                                <input type="text" class="form-control" formControlName="price" placeholder="e.g., 250000">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Monthly Rent</label>
                                <input type="number" class="form-control" formControlName="monthlyRent" min="0" placeholder="0">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="form-label">Weekly Rent</label>
                                <input type="number" class="form-control" formControlName="weeklyRent" min="0" placeholder="0">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Rental Period</label>
                                <input type="text" class="form-control" formControlName="rentalPeriod" placeholder="e.g., 12 months">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Available Date</label>
                                <input type="date" class="form-control" formControlName="availableDate">
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Location Section -->
                        <div class="section-container" formGroupName="address">
                          <h5 class="section-title">Location</h5>
                          
                          <div class="form-group">
                            <label class="form-label">Property Address <span class="required">*</span></label>
                            <app-auto (setAddress)="onLocationChange($event)" 
                              [strictBounds]="boundsLimit" 
                              [LatLng]="defaultBounds"
                              adressType="geocode" 
                              title="Property Address">
                            </app-auto>
                            <div class="mt-2" *ngIf="!hasGoogleSelection || !(form?.get('address.location.coordinates')?.value && form?.get('address.location.coordinates')?.value.length === 2)">
                              <small class="text-danger">Please select a location from Google suggestions.</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Landmark</label>
                                <input type="text" class="form-control" formControlName="landMark" placeholder="Nearby landmark">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Contact Number (Address)</label>
                                <input type="text" class="form-control" formControlName="contactNo" placeholder="Contact number">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Alternate Contact Number</label>
                                <input type="text" class="form-control" formControlName="alternateNo" placeholder="Alternate number">
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Contact Information Section -->
                        <div class="section-container">
                          <h5 class="section-title">Contact Information</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Contact Number <span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="contactNumber"
                                  placeholder="Contact Number"
                                  [ngClass]="{'is-invalid': submitted && f.contactNumber.errors}">
                                <div *ngIf="submitted && f.contactNumber.errors" class="invalid-feedback">
                                  Contact number is required (or provide email)
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Email</label>
                                <input type="email" class="form-control" formControlName="email"
                                  placeholder="Email"
                                  [ngClass]="{'is-invalid': submitted && f.email.errors}">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                  <div *ngIf="f.email.errors.email">Please enter a valid email</div>
                                </div>
                                <small class="text-muted">Either email or contact number is required</small>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Name</label>
                                <input type="text" class="form-control" formControlName="name" placeholder="Your name">
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Contact Instructions</label>
                            <textarea class="form-control" formControlName="contactInstruction" rows="3"
                              placeholder="Instructions for contacting you"></textarea>
                          </div>
                        </div>

                        <!-- Additional Information Section -->
                        <div class="section-container" formGroupName="additionalInformation">
                          <h5 class="section-title">Additional Information</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Parking</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of parkingOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Parking', option)"
                                      (change)="toggleAdditionalInfo('Parking', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Laundry</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of laundryOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Laundry', option)"
                                      (change)="toggleAdditionalInfo('Laundry', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Flooring</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of flooringOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Flooring', option)"
                                      (change)="toggleAdditionalInfo('Flooring', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Furnished</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of furnishedOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Furnished', option)"
                                      (change)="toggleAdditionalInfo('Furnished', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Smoking</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of smokingOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Smoking', option)"
                                      (change)="toggleAdditionalInfo('Smoking', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Amenities</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of amenitiesOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('Amenities', option)"
                                      (change)="toggleAdditionalInfo('Amenities', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">EV Charging</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of evChargingOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('EVCharging', option)"
                                      (change)="toggleAdditionalInfo('EVCharging', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Wheelchair Accessible</label>
                                <div class="checkbox-group">
                                  <label class="checkbox-label" *ngFor="let option of wheelchairOptions">
                                    <input type="checkbox" [checked]="isAdditionalInfoSelected('WheelchairAccessible', option)"
                                      (change)="toggleAdditionalInfo('WheelchairAccessible', option)">
                                    <span>{{option}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Pets Section -->
                        <div class="section-container">
                          <h5 class="section-title">Pets</h5>
                          <div formArrayName="pets">
                            <div *ngFor="let pet of petsArray.controls; let i = index" class="row mb-2">
                              <div class="col-md-10">
                                <select class="form-control" [formControlName]="i">
                                  <option value="">Select Pet Type</option>
                                  <option *ngFor="let petType of petOptions" [value]="petType">{{petType}}</option>
                                </select>
                              </div>
                              <div class="col-md-2">
                                <button type="button" class="btn btn-danger" (click)="removePet(i)">Remove</button>
                              </div>
                            </div>
                            <button type="button" class="btn btn-secondary" (click)="addPet()">Add Pet</button>
                          </div>
                        </div>

                        <!-- Other Information Section -->
                        <div class="section-container">
                          <h5 class="section-title">Other Information</h5>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Duration (days)</label>
                                <input type="number" class="form-control" formControlName="duration" min="0" placeholder="Posting duration">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label">Open House Info</label>
                                <input type="text" class="form-control" formControlName="openHouseInfo" placeholder="Open house information">
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="form-label">Description</label>
                            <textarea class="form-control" formControlName="description" rows="5"
                              placeholder="Property description"></textarea>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="isAvailable">
                                <span>Available</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="isShowProfile">
                                <span>Show Profile</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="checkbox-label">
                                <input type="checkbox" formControlName="isFavorite">
                                <span>Favorite</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- Submit Buttons -->
                        <div class="form-actions">
                          <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
                          <button type="submit" class="btn btn-primary">{{ isEditMode ? 'Update Property' : 'Create Property' }}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Property Details Modal -->
  <ng-template #postDetailsModal let-modal>
    <div class="modal-header job-modal-header">
      <h4 class="modal-title" id="post-details-modal">Property Details</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body job-modal-body" *ngIf="selectedPost">
      <div class="job-detail-header">
        <div class="job-detail-title-section">
          <h3 class="job-detail-title">{{ selectedPost?.roomTitle || 'Untitled Property' }}</h3>
          <p class="job-detail-company">{{ selectedPost?.propertyType || '-' }} - {{ selectedPost?.sellStatus || '-' }}</p>
        </div>
        <div class="job-detail-badges">
          <span class="job-badge job-badge--expired" *ngIf="isPostExpired(selectedPost?.activeTill)">
            Expired
          </span>
          <span class="job-badge job-badge--active" *ngIf="!isPostExpired(selectedPost?.activeTill)">
            {{ selectedPost?.status || 'Active' }}
          </span>
        </div>
      </div>

      <div class="job-detail-grid">
        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Property Information</h5>
          <div class="job-detail-item" *ngIf="selectedPost?.sellStatus">
            <i class="fas fa-tag"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Sell Status</span>
              <span class="job-detail-value">{{ selectedPost.sellStatus }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.propertyType">
            <i class="fas fa-home"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Property Type</span>
              <span class="job-detail-value">{{ selectedPost.propertyType }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.housingType">
            <i class="fas fa-building"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Housing Type</span>
              <span class="job-detail-value">{{ selectedPost.housingType }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.bedRoomCount">
            <i class="fas fa-bed"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Bedrooms</span>
              <span class="job-detail-value">{{ selectedPost.bedRoomCount }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.washRoomCount">
            <i class="fas fa-bath"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Bathrooms</span>
              <span class="job-detail-value">{{ selectedPost.washRoomCount }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.propertyArea">
            <i class="fas fa-ruler-combined"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Property Area</span>
              <span class="job-detail-value">{{ selectedPost.propertyArea }} {{ selectedPost.propertyUnitArea || '' }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.price">
            <i class="fas fa-dollar-sign"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Price</span>
              <span class="job-detail-value">${{ selectedPost.price }}</span>
            </div>
          </div>
        </div>

        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Location</h5>
          <div class="job-detail-item" *ngIf="getFullAddress(selectedPost) !== '-'">
            <i class="fas fa-map-marker-alt"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Address</span>
              <span class="job-detail-value">{{ getFullAddress(selectedPost) }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.address?.contactNo">
            <i class="fas fa-phone"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Contact Number</span>
              <span class="job-detail-value">{{ selectedPost.address.contactNo }}</span>
            </div>
          </div>
        </div>

        <div class="job-detail-section" *ngIf="selectedPost?.description">
          <h5 class="job-detail-section-title">Description</h5>
          <div class="job-detail-item">
            <div class="job-detail-item-content">
              <p class="job-detail-text">{{ selectedPost.description }}</p>
            </div>
          </div>
        </div>

        <div class="job-detail-section">
          <h5 class="job-detail-section-title">Contact Information</h5>
          <div class="job-detail-item" *ngIf="selectedPost?.name">
            <i class="fas fa-user"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Name</span>
              <span class="job-detail-value">{{ selectedPost.name }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.email">
            <i class="fas fa-envelope"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Email</span>
              <span class="job-detail-value">{{ selectedPost.email }}</span>
            </div>
          </div>
          <div class="job-detail-item" *ngIf="selectedPost?.contactNumber">
            <i class="fas fa-phone"></i>
            <div class="job-detail-item-content">
              <span class="job-detail-label">Contact Number</span>
              <span class="job-detail-value">{{ selectedPost.contactNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer job-modal-footer">
      <button type="button" class="btn btn-primary" (click)="editPost(selectedPost); modal.dismiss('Edit click')">
        <i class="fas fa-edit"></i> Edit Property
      </button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Close</button>
    </div>
  </ng-template>
</div>
